import loDashMerge from 'lodash/merge';

const metricsStore = {};

const update = (data: any) => {
  loDashMerge(metricsStore, data);
};

export default {
  update,
  store: metricsStore,
};
